import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

// COMPONENTS
import ShowsMoviesCarousel from '@/components/Carousels/ShowsMoviesCarousel';

// ASSETS
import PeerLogixLogo from '@/assets/images/logos/services/peerlogix.png';

// STYLES
import { Wrapper } from './styles';

const SimilarContent = props => {
  const { loading, data, title, analyticsLocation, poweredBy } = props;

  const [t] = useTranslation();
  const { isSimpleView, partner, partnerSettings } = useSelector(
    ({ app, partner: partnerStore }) => ({
      isSimpleView: app.isSimpleView,
      partner: partnerStore.data,
      partnerSettings: partnerStore.data?.settings || {},
    }),
  );
  const isPartner = !!partner.partner_slug;
  let useShowMovies = true;

  if (isPartner) {
    useShowMovies =
      !!partnerSettings.use_authorizing && !!partnerSettings.search_movies_shows && !isSimpleView;
  }

  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <Wrapper className="section-wrapper similar-content-section">
      <div className="page-content">
        <ShowsMoviesCarousel
          title={title}
          data={data || []}
          loading={loading}
          stylesType="collections"
          showSeeAll={useShowMovies}
          analyticsLocation={analyticsLocation}
        />
        {hasData && poweredBy && (
          <div className="similar-content-section__powered-by">
            <Typography className="p4">{t('common.recommendationsBy')}</Typography>
            <img src={PeerLogixLogo} alt="logo" />
          </div>
        )}
      </div>
    </Wrapper>
  );
};

SimilarContent.defaultProps = {
  analyticsLocation: '',
  loading: false,
};

SimilarContent.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string.isRequired,
  analyticsLocation: PropTypes.string,
  loading: PropTypes.bool,
  poweredBy: PropTypes.bool,
};

export default React.memo(SimilarContent);
